<template>
  <div class="edit-form">
    <loading v-if="!editingData || !options" :message="'データ読み込み中...'"></loading>

    <template v-else>
      <!-- 所属 -->
      <div class="row">
        <syozoku-detail :editingData="editingData" :options="options"></syozoku-detail>
      </div>

      <!-- 申請種別、雇用形態種別、雇用期間の定め -->
      <div class="row">
        <shinsei-type-detail :editingData="editingData" :options="options"></shinsei-type-detail>
        <koyou-type-detail :editingData="editingData" :currentData="currentData" :options="options"></koyou-type-detail>
        <keitai-type-detail :editingData="editingData" :currentData="currentData" :options="options"></keitai-type-detail>
      </div>

      <div class="row">
        <keiyaku-koushin-type-detail :editingData="editingData" :currentData="currentData"
          :options="options"></keiyaku-koushin-type-detail>
      </div>

      <!-- 氏名、カナ -->
      <div class="row">
        <user-name-edit :editingData="editingData" :currentData="currentData" :mode="mode"></user-name-edit>
      </div>

      <!-- 氏名、カナ -->
      <div class="row">
        <user-kana-edit v-if="
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ENTRY ||
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY" :editingData="editingData"
          :currentData="currentData"></user-kana-edit>
        <user-kana-detail v-if="
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.UPDATE ||
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE ||
          editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ADD" :editingData="editingData"
          :currentData="currentData"></user-kana-detail>
      </div>

      <!-- 社員番号 -->
      <div class="row" v-if="
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.UPDATE ||
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE ||
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.ADD
      ">
        <!-- 社員番号は、「入社」「入替（入社）」の場合は現行のExcelより、表示不要と判断 -->
        <user-staff-code-detail :editingData="editingData" />
      </div>

      <!-- 入替社員氏名、引継期間終了日 -->
      <div class="row"
        v-if="editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE_ENTRY || editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.REPLACE">
        <change-user-name-detail :editingData="editingData" :currentData="currentData"></change-user-name-detail>
        <hikitsugi-end-date-edit :editingData="editingData"></hikitsugi-end-date-edit>
      </div>

      <!-- 入社日、請求開始予定年月日 -->
      <div class="row">
        <nyuusya-date-detail :editingData="editingData" :currentData="currentData"></nyuusya-date-detail>
      </div>

      <!-- 雇用期間 -->
      <div class="row">
        <koyou-kikan-edit :editingData="editingData" :currentData="currentData"></koyou-kikan-edit>
      </div>

      <div class="row">
        <seikyu-start-date-edit :editingData="editingData"></seikyu-start-date-edit>
      </div>

      <!-- 協定対象派遣、当該協定の有効期間の終了日（PGの場合のみ） TODO: 所属による分岐（外販時になくしたい）-->
      <template v-if="editingData.syozoku_id === OptionConst.SYOZOKU.PG">
        <div class="row">
          <is-kyoutei-edit :editingData="editingData" :currentData="currentData" :options="options"></is-kyoutei-edit>
        </div>
        <div class="row" v-if="editingData.is_kyoutei === true">
          <kyoutei-end-date-edit :editingData="editingData" :currentData="currentData"></kyoutei-end-date-edit>
        </div>
      </template>


      <!-- 就業場所（就業場所、部課、TEL、住所） -->
      <div class="row">
        <syuugyou-basyo-edit :editingData="editingData" :currentData="currentData" :mode="mode"></syuugyou-basyo-edit>
      </div>

      <!-- 業務内容 -->
      <div class="row">
        <work-detail1-edit :editingData="editingData" :currentData="currentData"></work-detail1-edit>
      </div>

      <!-- 業務内容（詳細） -->
      <div class="row">
        <work-detail2-edit :editingData="editingData" :currentData="currentData"></work-detail2-edit>
      </div>

      <!-- 就業時間 -->
      <div class="row">
        <work-times-edit :editingData="editingData" :currentData="currentData" :options="options"></work-times-edit>
      </div>

      <!-- 有給取得時の差し引き時間 -->
      <div class="row">
        <sashihiki-times-edit :editingData="editingData" :currentData="currentData"
          :options="options"></sashihiki-times-edit>
      </div>

      <!-- 休日 -->
      <div class="row">
        <kyujitsu-detail></kyujitsu-detail>
      </div>

      <!-- (就業時間に関する) 備考／旧・休日増減 -->
      <div class="row">
        <kyujitsu-zougen-notes-edit :editingData="editingData" :currentData="currentData"></kyujitsu-zougen-notes-edit>
      </div>

      <!-- 時間外及び休日労働 -->
      <div class="row">
        <is-jikangai-edit :editingData="editingData" :currentData="currentData" :options="options"></is-jikangai-edit>
      </div>

      <!-- 時間外手当の考え -->
      <!-- 現状は、時間外及び休日労働がfalseの場合も、「時間外手当の考え（伺い書のみで、不要項目かはお客様確認中のため）」は編集可能としている -->
      <div class="row">
        <jikangai-notes-edit :editingData="editingData" :currentData="currentData"></jikangai-notes-edit>
      </div>

      <!-- 所定労働日数（週）、所定労働時間（週） -->
      <div class="row">
        <syotei-work-week-days-edit :editingData="editingData" :currentData="currentData"
          :options="options"></syotei-work-week-days-edit>
      </div>

      <div class="row">
        <syotei-work-week-times-edit :editingData="editingData" :currentData="currentData"
          :options="options"></syotei-work-week-times-edit>
      </div>

      <!-- 所定労働時間（月） -->
      <div class="row">
        <syotei-work-month-times-edit :editingData="editingData" :currentData="currentData"
          :options="options"></syotei-work-month-times-edit>
      </div>

      <!-- 包括時間 -->
      <div class="row">
        <houkatsu-times-edit :editingData="editingData" :currentData="currentData"
          :options="options"></houkatsu-times-edit>
      </div>

      <!-- 労災保険 -->
      <div class="row">
        <is-rousai-hoken-deatil></is-rousai-hoken-deatil>
      </div>

      <!-- 雇用保険、社会保険 -->
      <div class="row">
        <is-koyou-hoken-edit :editingData="editingData" :currentData="currentData"
          :options="options"></is-koyou-hoken-edit>
      </div>

      <div class="row">
        <is-syakai-hoken-edit :editingData="editingData" :currentData="currentData"
          :options="options"></is-syakai-hoken-edit>
      </div>

      <!-- 年次有給休暇 -->
      <div class="row">
        <yuukyuu-days-edit :editingData="editingData" :currentData="currentData"></yuukyuu-days-edit>
      </div>

      <!-- 締め日 -->
      <div class="row">
        <shime-day-edit :editingData="editingData" :currentData="currentData" :options="options"></shime-day-edit>
      </div>

      <!-- 支払い日 -->
      <div class="row">
        <pay-day-detail :editingData="editingData"></pay-day-detail>
      </div>

      <!-- 基本給 -->
      <div class="row">
        <kihonkyuu-edit :editingData="editingData"></kihonkyuu-edit>
      </div>

      <!-- PG時給タイプの月給換算（PG雇入れ連絡票用のための参考表示） -->
      <div class="row" v-if="editingData.is_jikyuu">
        <jikyuu-calc-detail :editingData="editingData"></jikyuu-calc-detail>
      </div>

      <!-- 手当 -->
      <div class="row" v-if="
        editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU ||
        editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI
      ">
        <teate-list-edit :editingData="editingData" :options="options"></teate-list-edit>
      </div>

      <!-- 通勤手当、通勤手当（課税） -->
      <div class="row">
        <koutsuuhi-edit :editingData="editingData" :currentData="currentData"></koutsuuhi-edit>
      </div>

      <!-- 残業（見込み） -->
      <div class="row">
        <zangyou-mikomi-edit :editingData="editingData" :currentData="currentData"></zangyou-mikomi-edit>
      </div>

      <!-- 賃金合計 -->
      <div class="row">
        <calc-salary-detail :editingData="editingData" :currentData="currentData"></calc-salary-detail>
      </div>

      <!-- 昇給、賞与 -->
      <div class="row">
        <is-syoukyuu-edit :editingData="editingData" :options="options"></is-syoukyuu-edit>
      </div>

      <!-- 退職金 -->
      <div class="row" v-if="editingData.syozoku_id === OptionConst.SYOZOKU.PM">
        <is-taisyokukin-detail :editingData="editingData"></is-taisyokukin-detail>
      </div>

      <div class="row" v-if="editingData.syozoku_id === OptionConst.SYOZOKU.PG">
        <is-taisyokukin-edit :editingData="editingData" :options="options"></is-taisyokukin-edit>
      </div>

      <!-- 自己都合退職 -->
      <div class="row">
        <retirement-self-detail></retirement-self-detail>
      </div>

      <!-- 定年 -->
      <div class="row">
        <retirement-age-detail></retirement-age-detail>
      </div>

      <!-- 解雇 -->
      <div class="row">
        <dismiss-detail></dismiss-detail>
      </div>

      <!-- その他、その他（相談窓口） -->
      <div class="row">
        <other-detail :editingData="editingData"></other-detail>
      </div>

      <!-- 更新の有無 -->
      <div class="row">
        <keiyaku-koushin-type-edit :editingData="editingData" :currentData="currentData"></keiyaku-koushin-type-edit>
      </div>

      <!-- 内容変更対象雇用契約書ID -->

      <div class="row" v-if="
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE">
        <koyou-keiyaku-tsuiseki :editingData="editingData" @error="$emit('backTypeSelect', true)"></koyou-keiyaku-tsuiseki>
      </div>

      <!-- 本人通知欄（変更内容） -->
      <div class="row" v-if="
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.CHANGE ||
        editingData.shinsei_type === OptionConst.KOYOU_SHINSEI_TYPE.UPDATE
      ">
        <honnin-notes-edit :editingData="editingData" :currentData="currentData"></honnin-notes-edit>
      </div>

      <!-- 社内メモ欄（備考、変更理由等） -->
      <div class="row">
        <syanai-notes-edit :editingData="editingData" :currentData="currentData"></syanai-notes-edit>
      </div>

      <!-- 担当営業者 -->
      <div class="row">
        <eigyou-user-id-edit :editingData="editingData" :currentData="currentData"
          :options="options"></eigyou-user-id-edit>
      </div>

      <!-- 添付ファイル -->
      <div class="row">
        <koyou-keiyaku-tenpufile-edit :editingData="editingData"></koyou-keiyaku-tenpufile-edit>
      </div>

    </template>

  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted } from 'vue';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import OptionConst from '@/const/Option';

// partsコンポーネント
import SyozokuDetail from '@/components/koyoukeiyaku/parts/SyozokuDetail.vue'
import ShinseiTypeDetail from '@/components/koyoukeiyaku/parts/ShinseiTypeDetail.vue'
import KoyouTypeDetail from '@/components/koyoukeiyaku/parts/KoyouTypeDetail.vue'
import KeiyakuKoushinTypeDetail from '@/components/koyoukeiyaku/parts/KeiyakuKoushinTypeDetail.vue'
import UserNameEdit from '@/components/koyoukeiyaku/parts/UserNameEdit.vue'
import UserKanaEdit from '@/components/koyoukeiyaku/parts/UserKanaEdit.vue'
import UserKanaDetail from '@/components/koyoukeiyaku/parts/UserKanaDetail.vue'
import UserStaffCodeDetail from '@/components/koyoukeiyaku/parts/UserStaffCodeDetail.vue'
import NyuusyaDateDetail from '@/components/koyoukeiyaku/parts/NyuusyaDateDetail.vue'
import SeikyuStartDateEdit from '@/components/koyoukeiyaku/parts/SeikyuStartDateEdit.vue'
import ChangeUserNameDetail from '@/components/koyoukeiyaku/parts/ChangeUserNameDetail.vue'
import HikitsugiEndDateEdit from '@/components/koyoukeiyaku/parts/HikitsugiEndDateEdit.vue'
import IsKyouteiEdit from '@/components/koyoukeiyaku/parts/IsKyouteiEdit.vue'
import KyouteiEndDateEdit from '@/components/koyoukeiyaku/parts/KyouteiEndDateEdit.vue'
import KoyouKikanEdit from '@/components/koyoukeiyaku/parts/KoyouKikanEdit.vue'
import SyuugyouBasyoEdit from '@/components/koyoukeiyaku/parts/SyuugyouBasyoEdit.vue'
import WorkDetail1Edit from '@/components/koyoukeiyaku/parts/WorkDetail1Edit.vue'
import WorkDetail2Edit from '@/components/koyoukeiyaku/parts/WorkDetail2Edit.vue'
import WorkTimesEdit from '@/components/koyoukeiyaku/parts/WorkTimesEdit.vue'
import KyujitsuDetail from '@/components/koyoukeiyaku/parts/KyujitsuDetail.vue'
import KyujitsuZougenNotesEdit from '@/components/koyoukeiyaku/parts/KyujitsuZougenNotesEdit.vue'
import IsJikangaiEdit from '@/components/koyoukeiyaku/parts/IsJikangaiEdit.vue'
import JikangaiNotesEdit from '@/components/koyoukeiyaku/parts/JikangaiNotesEdit.vue'
import SyoteiWorkWeekDaysEdit from '@/components/koyoukeiyaku/parts/SyoteiWorkWeekDaysEdit.vue'
import SyoteiWorkWeekTimesEdit from '@/components/koyoukeiyaku/parts/SyoteiWorkWeekTimesEdit.vue'
import SyoteiWorkMonthTimesEdit from '@/components/koyoukeiyaku/parts/SyoteiWorkMonthTimesEdit.vue'
import HoukatsuTimesEdit from '@/components/koyoukeiyaku/parts/HoukatsuTimesEdit.vue'
import SashihikiTimesEdit from '@/components/koyoukeiyaku/parts/SashihikiTimesEdit.vue'
import IsRousaiHokenDeatil from '@/components/koyoukeiyaku/parts/IsRousaiHokenDeatil.vue'
import IsKoyouHokenEdit from '@/components/koyoukeiyaku/parts/IsKoyouHokenEdit.vue'
import IsSyakaiHokenEdit from '@/components/koyoukeiyaku/parts/IsSyakaiHokenEdit.vue'
import YuukyuuDaysEdit from '@/components/koyoukeiyaku/parts/YuukyuuDaysEdit.vue'
import ShimeDayEdit from '@/components/koyoukeiyaku/parts/ShimeDayEdit.vue'
import PayDayDetail from '@/components/koyoukeiyaku/parts/PayDayDetail.vue'
import KihonkyuuEdit from '@/components/koyoukeiyaku/parts/KihonkyuuEdit.vue'
import JikyuuCalcDetail from '@/components/koyoukeiyaku/parts/JikyuuCalcDetail.vue'
import TeateListEdit from '@/components/koyoukeiyaku/parts/TeateListEdit.vue'
import KoutsuuhiEdit from '@/components/koyoukeiyaku/parts/KoutsuuhiEdit.vue'
import ZangyouMikomiEdit from '@/components/koyoukeiyaku/parts/ZangyouMikomiEdit.vue'
import CalcSalaryDetail from '@/components/koyoukeiyaku/parts/CalcSalaryDetail.vue'
import IsSyoukyuuEdit from '@/components/koyoukeiyaku/parts/IsSyoukyuuEdit.vue'
import IsTaisyokukinEdit from '@/components/koyoukeiyaku/parts/IsTaisyokukinEdit.vue'
import IsTaisyokukinDetail from '@/components/koyoukeiyaku/parts/IsTaisyokukinDetail.vue'
import RetirementSelfDetail from '@/components/koyoukeiyaku/parts/RetirementSelfDetail.vue'
import RetirementAgeDetail from '@/components/koyoukeiyaku/parts/RetirementAgeDetail.vue'
import DismissDetail from '@/components/koyoukeiyaku/parts/DismissDetail.vue'
import OtherDetail from '@/components/koyoukeiyaku/parts/OtherDetail.vue'
import KeiyakuKoushinTypeEdit from '@/components/koyoukeiyaku/parts/KeiyakuKoushinTypeEdit.vue'
import KoyouKeiyakuTsuisekiEdit from '@/components/koyoukeiyaku/parts/KoyouKeiyakuTsuisekiEdit.vue'
import HonninNotesEdit from '@/components/koyoukeiyaku/parts/HonninNotesEdit.vue'
import SyanaiNotesEdit from '@/components/koyoukeiyaku/parts/SyanaiNotesEdit.vue'
import EigyouUserIdEdit from '@/components/koyoukeiyaku/parts/EigyouUserIdEdit.vue'
import KoyouKeiyakuTenpufileEdit from '@/components/koyoukeiyaku/parts/KoyouKeiyakuTenpufileEdit.vue'
import KeitaiTypeDetail from '@/components/koyoukeiyaku/parts/KeitaiTypeDetail.vue'

export default defineComponent({
  props: {
    mode: {
      // モード 新規新規(create)／既存契約からの新規作成(from)／編集(edit)／承認後の編集（modify）の４モードを想定
      type: String,
      require: true,
      default: null
    },
    editingData: {
      // 編集用オブジェクト
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      // 現在のデータ（原則、一切の変更を加えない）
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
  },
  emits: {
    backTypeSelect: (result: boolean) => true,
  },
  setup(props) {
    const { options, getAllKoyouKeiyakuOption } = useKoyouKeiyakuInit()

    onMounted(async () => {
      await getAllKoyouKeiyakuOption()
    })
    return {
      editingData: props.editingData,
      currentData: props.currentData,
      options,
      OptionConst,
    }
  },
  components: {
    'syozoku-detail': SyozokuDetail,
    'shinsei-type-detail': ShinseiTypeDetail,
    'koyou-type-detail': KoyouTypeDetail,
    'keiyaku-koushin-type-detail': KeiyakuKoushinTypeDetail,
    'user-name-edit': UserNameEdit,
    'user-kana-edit': UserKanaEdit,
    'user-kana-detail': UserKanaDetail,
    'user-staff-code-detail': UserStaffCodeDetail,
    'nyuusya-date-detail': NyuusyaDateDetail,
    'seikyu-start-date-edit': SeikyuStartDateEdit,
    'change-user-name-detail': ChangeUserNameDetail,
    'hikitsugi-end-date-edit': HikitsugiEndDateEdit,
    'is-kyoutei-edit': IsKyouteiEdit,
    'koyou-kikan-edit': KoyouKikanEdit,
    'kyoutei-end-date-edit': KyouteiEndDateEdit,
    'syuugyou-basyo-edit': SyuugyouBasyoEdit,
    'work-detail1-edit': WorkDetail1Edit,
    'work-detail2-edit': WorkDetail2Edit,
    'work-times-edit': WorkTimesEdit,
    'kyujitsu-detail': KyujitsuDetail,
    'kyujitsu-zougen-notes-edit': KyujitsuZougenNotesEdit,
    'is-jikangai-edit': IsJikangaiEdit,
    'jikangai-notes-edit': JikangaiNotesEdit,
    'syotei-work-week-days-edit': SyoteiWorkWeekDaysEdit,
    'syotei-work-week-times-edit': SyoteiWorkWeekTimesEdit,
    'syotei-work-month-times-edit': SyoteiWorkMonthTimesEdit,
    'houkatsu-times-edit': HoukatsuTimesEdit,
    'sashihiki-times-edit': SashihikiTimesEdit,
    'is-rousai-hoken-deatil': IsRousaiHokenDeatil,
    'is-koyou-hoken-edit': IsKoyouHokenEdit,
    'is-syakai-hoken-edit': IsSyakaiHokenEdit,
    'yuukyuu-days-edit': YuukyuuDaysEdit,
    'shime-day-edit': ShimeDayEdit,
    'pay-day-detail': PayDayDetail,
    'kihonkyuu-edit': KihonkyuuEdit,
    'jikyuu-calc-detail': JikyuuCalcDetail,
    'teate-list-edit': TeateListEdit,
    'koutsuuhi-edit': KoutsuuhiEdit,
    'zangyou-mikomi-edit': ZangyouMikomiEdit,
    'calc-salary-detail': CalcSalaryDetail,
    'is-syoukyuu-edit': IsSyoukyuuEdit,
    'is-taisyokukin-edit': IsTaisyokukinEdit,
    'is-taisyokukin-detail': IsTaisyokukinDetail,
    'retirement-self-detail': RetirementSelfDetail,
    'retirement-age-detail': RetirementAgeDetail,
    'dismiss-detail': DismissDetail,
    'other-detail': OtherDetail,
    'keiyaku-koushin-type-edit': KeiyakuKoushinTypeEdit,
    'koyou-keiyaku-tsuiseki': KoyouKeiyakuTsuisekiEdit,
    'honnin-notes-edit': HonninNotesEdit,
    'syanai-notes-edit': SyanaiNotesEdit,
    'eigyou-user-id-edit': EigyouUserIdEdit,
    'koyou-keiyaku-tenpufile-edit': KoyouKeiyakuTenpufileEdit,
    'keitai-type-detail': KeitaiTypeDetail,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
